import { useEffect, useState } from "react";

const API = "/api";
const token = () => localStorage.getItem("token");

const coloresAccion: any = {
  crear: "#22c55e", editar: "#3b82f6", eliminar: "#ef4444",
  activar: "#22c55e", desactivar: "#f59e0b",
};
const iconosAccion: any = {
  crear: "➕", editar: "✏️", eliminar: "🗑️", activar: "✅", desactivar: "⏸️",
};
const etiquetasEntidad: any = {
  cliente: "Cliente", venta_credito: "Venta a crédito", abono: "Abono",
};

export default function Auditoria() {
  const [registros, setRegistros] = useState<any[]>([]);
  const [filtroEntidad, setFiltroEntidad] = useState("");
  const [cargando, setCargando] = useState(true);

  const cargar = () => {
    setCargando(true);
    const qs = filtroEntidad ? `?entidad=${filtroEntidad}` : "";
    fetch(`${API}/reportes/auditoria${qs}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(d => { if (Array.isArray(d)) setRegistros(d); })
      .catch(() => {})
      .finally(() => setCargando(false));
  };
  useEffect(() => { cargar(); }, [filtroEntidad]);

  return (
    <div>
      <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "24px", fontWeight: 900, marginBottom: "20px", color: "#1a1a2e" }}>
        Auditoría
      </h1>
      <p style={{ color: "#6b7280", fontSize: "13px", marginBottom: "20px" }}>
        Registro de quién creó, editó o eliminó clientes, ventas y abonos.
      </p>

      <div style={{ display: "flex", gap: "10px", marginBottom: "16px", flexWrap: "wrap" }}>
        {[
          { id: "", label: "Todo" },
          { id: "cliente", label: "Clientes" },
          { id: "venta_credito", label: "Ventas" },
          { id: "abono", label: "Abonos" },
        ].map(t => (
          <button key={t.id} onClick={() => setFiltroEntidad(t.id)}
            style={{ background: filtroEntidad === t.id ? "#0D47A1" : "#fff", color: filtroEntidad === t.id ? "#fff" : "#374151", border: "1.5px solid #e5e7eb", borderRadius: "10px", padding: "8px 16px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {registros.map(r => (
          <div key={r.id} style={{ background: "#fff", borderRadius: "14px", padding: "14px 18px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", display: "flex", alignItems: "flex-start", gap: "12px", borderLeft: `4px solid ${coloresAccion[r.accion] || "#9ca3af"}` }}>
            <div style={{ fontSize: "18px" }}>{iconosAccion[r.accion] || "•"}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: "14px", color: "#1a1a2e" }}>{r.detalle}</div>
              <div style={{ fontSize: "12px", color: "#9ca3af", marginTop: "4px" }}>
                <span style={{ fontWeight: 700, color: coloresAccion[r.accion] || "#6b7280", textTransform: "uppercase" }}>{r.accion}</span>
                {" · "}{etiquetasEntidad[r.entidad] || r.entidad}
                {" · "}por <strong>{r.usuario || "—"}</strong>
                {" · "}{new Date(r.fecha).toLocaleString()}
              </div>
            </div>
          </div>
        ))}
        {!cargando && registros.length === 0 && (
          <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", background: "#fff", borderRadius: "16px" }}>
            No hay movimientos registrados todavía
          </div>
        )}
      </div>
    </div>
  );
}
